export const northAmericaGeoURL = {
  type: "Topology",
  arcs: [
    [
      [9680, 4301],
      [36, -101],
      [-30, -91],
      [-29, 82],
      [23, 110],
    ],
    [
      [8703, 2838],
      [20, -83],
      [-18, -114],
      [6, -137],
      [-31, -149],
      [-36, -83],
    ],
    [
      [8644, 2272],
      [-31, 0],
      [9, 250],
      [-1, 170],
    ],
    [
      [8621, 2692],
      [26, 16],
      [38, 131],
      [18, -1],
    ],
    [
      [11368, 9081],
      [21, -147],
      [40, -86],
      [-51, -64],
      [-90, -17],
      [-20, 104],
      [65, 166],
      [35, 44],
    ],
    [
      [11029, 9043],
      [81, -86],
      [105, 11],
      [-65, -114],
      [-21, 47],
      [-61, 10],
      [-75, 101],
      [36, 31],
    ],
    [
      [10006, 8643],
      [110, 91],
      [40, 141],
      [137, 126],
      [40, 24],
      [13, 21],
      [60, 37],
      [142, 268],
      [82, 90],
      [151, 105],
      [102, 31],
      [91, -31],
      [37, -50],
      [-10, -104],
      [-92, -89],
      [44, -43],
      [-7, -204],
      [37, -141],
      [68, -22],
      [0, -55],
      [128, -60],
      [96, 15],
      [38, -101],
      [-187, -115],
      [-97, -28],
      [-94, -184],
      [-43, -44],
      [-63, 47],
      [-8, 80],
      [40, 129],
      [134, 147],
      [-47, 58],
      [-98, -93],
      [-81, -32],
      [-41, 25],
    ],
    [
      [10728, 8682],
      [-26, 95],
      [-34, 20],
      [0, 292],
      [-56, 58],
      [-50, -24],
      [-34, 54],
      [-71, -161],
      [-27, -178],
      [-52, -105],
      [-65, -87],
      [-307, -3],
    ],
    [
      [11020, 9727],
      [97, -36],
      [119, -94],
      [-35, -63],
      [-129, 70],
      [-52, 123],
    ],
    [
      [4908, 9928],
      [66, -54],
      [169, -68],
      [61, -184],
      [94, -77],
      [37, -148],
      [-16, -29],
      [-102, 57],
      [-103, 106],
      [-33, 72],
      [-47, 7],
      [-6, 88],
      [-49, 11],
      [-60, 80],
      [-61, 120],
      [50, 19],
    ],
    [
      [11811, 10092],
      [46, -12],
      [-108, -299],
      [73, -57],
      [-16, -72],
      [68, -75],
      [113, 47],
      [57, -52],
      [-45, -71],
      [38, -100],
      [-31, -165],
      [57, -18],
      [45, -69],
      [-15, -114],
      [-65, -29],
      [4, 111],
      [-30, 80],
      [-55, -7],
      [-80, -50],
      [-90, 79],
      [-133, -6],
      [-45, 20],
      [-98, -29],
      [-27, 70],
      [82, 125],
      [-26, 26],
      [84, 248],
      [117, 354],
      [80, 65],
    ],
    [
      [4533, 10450],
      [-32, -109],
      [-38, 78],
      [70, 31],
    ],
    [
      [4418, 10649],
      [123, -46],
      [-28, -153],
      [-72, 14],
      [-37, 127],
      [14, 58],
    ],
    [
      [9552, 12448],
      [17, -52],
      [-36, -106],
      [-51, 25],
      [-4, 80],
      [74, 53],
    ],
    [
      [9297, 12577],
      [14, -60],
      [-113, -114],
      [-74, 69],
      [37, 74],
      [136, 31],
    ],
    [
      [8973, 13196],
      [133, -129],
      [166, -96],
      [57, -56],
      [26, -105],
      [59, 19],
      [40, -86],
      [-53, -61],
      [-101, 53],
      [-44, 62],
      [-106, -45],
      [-91, -99],
      [-100, -16],
      [1, 94],
      [-154, -3],
      [99, 97],
      [-20, 74],
      [36, 268],
      [52, 29],
    ],
    [
      [9921, 13747],
      [44, -17],
      [7, -150],
      [-79, -64],
      [-105, -3],
      [-33, 101],
      [61, 122],
      [105, 11],
    ],
    [
      [7832, 14028],
      [112, -62],
      [36, -93],
      [-43, -90],
      [-300, 90],
      [11, 59],
      [184, 96],
    ],
    [
      [10006, 8643],
      [-54, -30],
      [-113, -170],
      [-37, -101],
      [-177, 2],
      [-47, -37],
      [15, -145],
      [-118, -95],
      [-99, -35],
      [-110, -116],
      [-61, 37],
      [-6, 86],
      [59, 89],
      [35, 209],
      [-37, 371],
      [-102, 114],
      [-54, 135],
      [-41, 9],
      [-28, 93],
      [-332, 306],
      [-96, -68],
      [-80, 28],
      [-120, -17],
      [-117, 109],
      [-58, 21],
      [-48, -25],
      [-136, 104],
      [-190, 0],
      [-295, 0],
      [-400, 0],
      [-232, 0],
      [-253, 0],
      [-232, 0],
      [-358, 0],
      [-274, 0],
      [-232, 0],
      [-178, 0],
    ],
    [
      [5400, 9517],
      [-27, 0],
    ],
    [
      [5373, 9517],
      [-5, 0],
    ],
    [
      [5368, 9517],
      [-19, 86],
      [-65, 30],
      [-74, 95],
      [13, 61],
      [-71, 56],
      [-86, 3],
      [6, 77],
      [-81, -7],
      [-72, 75],
      [-3, 239],
      [-42, 66],
      [-29, 126],
      [-76, 57],
      [-74, 121],
      [-34, 88],
      [48, 202],
      [-6, 139],
    ],
    [
      [4703, 11031],
      [-4, 39],
      [-99, 71],
      [-97, 98],
      [8, 37],
      [-131, 301],
      [-163, 223],
      [-37, 81],
      [-75, -37],
      [-20, -73],
      [-91, -83],
      [-18, 72],
      [-151, 183],
      [-174, 54],
      [0, 383],
      [0, 606],
      [-1, 415],
      [0, 639],
    ],
    [
      [3650, 14040],
      [179, -31],
      [187, -123],
      [108, -14],
      [22, 93],
      [137, 76],
      [74, -57],
      [143, 64],
      [115, 85],
      [252, -19],
      [113, 57],
      [85, -159],
      [117, 49],
      [92, -18],
      [107, 38],
      [146, -16],
      [110, -79],
      [155, -40],
      [60, -44],
      [176, -42],
      [117, 8],
      [89, -123],
      [-108, -36],
      [6, -74],
      [259, -26],
      [191, 58],
      [175, -71],
      [273, 174],
      [-248, -58],
      [6, 102],
      [192, 63],
      [71, -100],
      [101, -91],
      [107, -4],
      [176, -74],
      [78, 37],
      [172, -30],
      [172, 15],
      [-102, 115],
      [73, 44],
      [122, -61],
      [-30, -157],
      [116, -54],
      [-31, 139],
      [69, 29],
      [126, 117],
      [-54, 42],
      [-20, 152],
      [-208, 141],
      [29, 116],
      [-41, 44],
      [92, 102],
      [41, 144],
      [65, 11],
      [149, -141],
      [8, -100],
      [131, -165],
      [-89, -98],
      [131, -41],
      [106, -247],
      [32, 145],
      [70, 41],
      [95, -110],
      [15, -87],
      [-57, -66],
      [101, -188],
      [79, 45],
      [-2, 68],
      [60, 80],
      [22, 147],
      [87, 79],
      [-68, 43],
      [-4, 107],
      [113, 19],
      [169, -40],
      [32, -96],
      [93, -131],
      [-72, -45],
      [-6, -117],
      [81, -96],
      [-28, -102],
      [-207, -174],
      [-151, 19],
      [-57, -27],
      [-67, -108],
      [-79, -74],
      [43, -41],
      [-106, -210],
      [-67, -47],
      [-103, -5],
      [-34, -63],
      [-77, -18],
      [31, -111],
      [-155, -111],
      [-165, -242],
      [-80, -327],
      [1, -207],
      [31, -43],
      [128, -21],
      [2, -43],
      [87, -330],
      [114, 53],
      [116, -63],
      [89, -25],
      [88, -92],
      [34, -76],
      [186, -111],
      [53, -62],
      [115, 5],
      [141, -41],
      [25, -67],
      [-22, -133],
      [29, -91],
      [-17, -185],
      [71, -112],
      [16, -71],
      [77, -92],
      [16, -77],
      [65, -51],
      [18, 94],
      [69, 63],
      [24, 58],
      [-52, 438],
      [-44, 135],
      [60, 28],
      [113, 92],
      [106, 169],
      [17, 162],
      [-8, 107],
      [-47, 151],
      [-92, 93],
      [-42, 73],
      [114, 286],
      [-84, 184],
      [36, 128],
      [-35, 185],
      [63, 63],
      [160, -60],
      [135, -13],
      [72, 50],
      [193, -182],
      [25, -109],
      [142, -75],
      [30, -128],
      [-7, -168],
      [21, -123],
      [64, 6],
      [42, -66],
      [123, -50],
      [92, 85],
      [67, 139],
      [-14, 69],
      [109, 116],
      [16, -113],
      [82, -99],
      [78, -173],
      [-8, -71],
      [74, -121],
      [4, -271],
      [45, -90],
      [85, -36],
      [6, -116],
      [60, -37],
      [53, 23],
      [32, -79],
      [103, -26],
      [-33, -83],
      [80, -48],
      [19, -87],
      [107, -35],
      [28, -96],
      [-30, -83],
      [36, -143],
      [-123, -150],
      [-75, 8],
      [-68, -32],
      [-154, -233],
      [-171, -7],
      [-327, 22],
      [-123, -23],
      [-57, -84],
      [-23, -108],
      [-72, -15],
      [-90, -112],
      [-83, -216],
      [-75, -143],
      [-23, -21],
      [-38, -62],
      [-51, -11],
      [-107, -105],
      [-92, -187],
      [-72, -78],
    ],
    [
      [6220, 14840],
      [333, -161],
      [62, 93],
      [225, -147],
      [-54, 177],
      [141, 38],
      [143, -122],
      [28, -139],
      [73, -164],
      [-30, -64],
      [101, -104],
      [188, -102],
      [59, -103],
      [-105, -39],
      [9, -113],
      [-136, -41],
      [-240, 87],
      [-67, 71],
      [-72, -104],
      [-155, -62],
      [-220, -49],
      [-128, -2],
      [-103, 63],
      [7, 88],
      [-229, 22],
      [-63, 35],
      [-78, 116],
      [46, 30],
      [267, 41],
      [153, -25],
      [42, 64],
      [-177, 49],
      [-152, -30],
      [-192, 6],
      [-77, 91],
      [80, 77],
      [-144, 55],
      [44, 176],
      [117, 107],
      [267, 102],
      [37, -17],
    ],
    [
      [7141, 14841],
      [-58, -80],
      [-176, 118],
      [42, 49],
      [137, 10],
      [55, -97],
    ],
    [
      [9467, 14939],
      [299, -55],
      [86, -151],
      [-348, 6],
      [-92, 167],
      [55, 33],
    ],
    [
      [8870, 14960],
      [154, -41],
      [-103, -80],
      [-64, -107],
      [95, -39],
      [83, 165],
      [192, 76],
      [125, -5],
      [85, -119],
      [57, -169],
      [142, -9],
      [93, 87],
      [230, -56],
      [13, -81],
      [174, -175],
      [74, 70],
      [188, -156],
      [206, -77],
      [120, -187],
      [-98, -196],
      [20, -67],
      [92, -35],
      [72, -80],
      [99, -8],
      [86, -52],
      [38, -107],
      [95, -59],
      [86, 14],
      [70, -94],
      [-65, -128],
      [-148, -142],
      [9, -74],
      [-144, 54],
      [-197, 276],
      [-20, -133],
      [-73, -69],
      [83, -36],
      [40, -106],
      [79, -19],
      [9, -81],
      [95, -109],
      [24, -159],
      [-65, -158],
      [-48, 75],
      [-82, 37],
      [-189, 145],
      [-26, -41],
      [272, -297],
      [-33, -74],
      [-102, 61],
      [-117, 24],
      [-270, 175],
      [-169, 272],
      [-73, 58],
      [-78, -38],
      [-96, 43],
      [-58, -65],
      [-138, 14],
      [-41, 53],
      [21, 102],
      [123, 78],
      [89, -43],
      [120, 29],
      [75, 94],
      [-60, 99],
      [191, 195],
      [-62, 245],
      [-59, 9],
      [-199, 221],
      [-173, 126],
      [-18, 70],
      [-104, 2],
      [-12, -65],
      [-209, 45],
      [-75, -52],
      [-115, 32],
      [-262, -3],
      [-119, 104],
      [-79, -51],
      [-81, 50],
      [-72, 97],
      [-62, 227],
      [100, 286],
      [123, 102],
      [116, 30],
    ],
    [
      [7598, 14969],
      [58, -34],
      [158, 33],
      [-8, -187],
      [130, -134],
      [-25, -128],
      [-256, -108],
      [-135, 184],
      [-115, 30],
      [52, 86],
      [121, 48],
      [-146, 116],
      [64, 80],
      [102, 14],
    ],
    [
      [8277, 15010],
      [244, -40],
      [-159, -231],
      [-148, -11],
      [-66, -160],
      [-101, -22],
      [-43, 161],
      [-2, 196],
      [35, 91],
      [240, 16],
    ],
    [
      [5513, 15113],
      [136, -60],
      [200, 0],
      [115, -42],
      [148, -127],
      [-368, -192],
      [-98, -94],
      [-43, -156],
      [-236, -89],
      [-93, 135],
      [-165, 55],
      [70, 135],
      [19, 114],
      [104, 148],
      [-94, 128],
      [305, 45],
    ],
    [
      [8119, 15343],
      [86, -74],
      [-11, -134],
      [-107, -5],
      [-180, 95],
      [78, 95],
      [134, 23],
    ],
    [
      [7734, 15576],
      [71, -40],
      [23, -212],
      [-58, -108],
      [-220, -2],
      [10, 142],
      [-131, 57],
      [-43, 107],
      [170, 52],
      [178, 4],
    ],
    [
      [6750, 15610],
      [78, -166],
      [201, -17],
      [36, -73],
      [-60, -131],
      [-95, -29],
      [-247, -15],
      [-199, -78],
      [-131, -23],
      [-446, 197],
      [207, 254],
      [149, -58],
      [147, -4],
      [102, -100],
      [237, -49],
      [-62, 153],
      [-82, 45],
      [165, 94],
    ],
    [
      [8038, 15651],
      [147, -20],
      [97, -71],
      [120, 21],
      [120, -137],
      [186, -129],
      [197, -14],
      [218, 88],
      [269, -8],
      [155, -85],
      [10, -113],
      [-110, -68],
      [-120, -23],
      [-561, 0],
      [-221, 16],
      [-198, 54],
      [-44, 96],
      [45, 84],
      [-108, 168],
      [-165, -22],
      [-93, 29],
      [-99, 116],
      [155, 18],
    ],
    [
      [6036, 15752],
      [22, -170],
      [-258, -79],
      [-123, -104],
      [-287, 70],
      [387, 258],
      [259, 25],
    ],
    [
      [6661, 15883],
      [-61, -124],
      [-179, -39],
      [-105, 44],
      [-4, 82],
      [349, 37],
    ],
    [
      [7879, 16021],
      [176, -160],
      [-257, 15],
      [-59, 161],
      [140, -16],
    ],
    [
      [7231, 16161],
      [393, -163],
      [52, -154],
      [-153, -7],
      [-41, 74],
      [-236, 67],
      [11, 59],
      [-215, 83],
      [189, 41],
    ],
    [
      [8274, 16593],
      [205, -164],
      [282, -34],
      [69, -116],
      [197, -128],
      [-152, -50],
      [-134, -113],
      [-235, -89],
      [-169, 18],
      [-206, 162],
      [162, 91],
      [-294, 2],
      [-108, 149],
      [148, 206],
      [235, 66],
    ],
    [
      [10487, 16987],
      [368, -60],
      [231, -3],
      [204, -138],
      [-293, -103],
      [-31, -74],
      [-344, -138],
      [-274, -212],
      [-341, -74],
      [22, -49],
      [-107, -244],
      [-230, -65],
      [-29, -96],
      [-110, -30],
      [160, -126],
      [-143, -75],
      [-477, 27],
      [-93, -35],
      [-133, 43],
      [-247, -13],
      [-36, 95],
      [231, 78],
      [-104, 99],
      [70, 172],
      [303, 162],
      [-95, 107],
      [-109, 16],
      [2, 124],
      [-325, 152],
      [-181, 158],
      [291, 71],
      [164, -2],
      [115, 91],
      [293, -19],
      [109, 90],
      [214, 40],
      [493, 6],
      [432, 25],
    ],
    [
      [9149, 1184],
      [24, -120],
      [60, -157],
      [19, -18],
    ],
    [
      [9252, 889],
      [-35, -31],
      [10, -198],
      [-6, -109],
    ],
    [
      [9221, 551],
      [-27, 132],
      [-38, -42],
      [-16, 39],
      [11, 90],
      [-28, 57],
      [-58, 49],
      [-20, 98],
      [-40, -77],
      [-47, 64],
      [-22, 98],
      [23, 59],
      [-7, 100],
    ],
    [
      [8952, 1218],
      [74, -30],
      [24, 28],
      [72, -77],
      [27, 45],
    ],
    [
      [9969, 3148],
      [-4, 16],
    ],
    [
      [9965, 3164],
      [-2, 0],
    ],
    [
      [9963, 3164],
      [-7, -15],
    ],
    [
      [9956, 3149],
      [-98, 20],
      [-141, -34],
      [59, 116],
      [-20, 75],
      [-72, 0],
      [-41, 74],
      [-26, 130],
      [-46, -20],
      [-77, 47],
      [-37, 60],
      [-133, 33],
      [-5, 107],
      [-73, 0],
      [-75, -108],
      [-49, -3],
      [-36, -63],
      [-7, 109],
      [34, 65],
      [78, 71],
      [113, 43],
      [135, -24],
      [57, -31],
      [66, -117],
      [54, -5],
      [68, -67],
      [17, -46],
      [54, -24],
      [17, -59],
      [99, -88],
      [52, -18],
      [-7, -55],
      [62, -13],
      [49, -76],
      [-58, -100],
    ],
    [
      [10287, 2741],
      [-13, 86],
      [26, 171],
      [-11, 109],
    ],
    [
      [10289, 3107],
      [9, 40],
      [64, 10],
      [67, -61],
      [38, -5],
      [28, -119],
      [83, -28],
      [39, -85],
      [-49, -44],
      [-99, 21],
      [-27, -50],
      [-86, -22],
      [-34, -118],
      [-35, 95],
    ],
    [
      [12113, 14100],
      [57, -99],
      [-139, -52],
      [-28, 71],
      [-107, 31],
      [16, 109],
      [150, 0],
      [51, -60],
    ],
    [
      [14726, 14285],
      [-105, -54],
      [-48, 81],
      [39, 0],
      [92, 42],
      [22, -69],
    ],
    [
      [14874, 14747],
      [116, -54],
      [-33, -71],
      [-123, 61],
      [40, 64],
    ],
    [
      [14081, 17096],
      [628, -69],
      [191, -101],
      [224, -51],
      [29, -182],
      [371, -79],
      [64, 74],
      [246, 14],
      [218, -93],
      [-362, -162],
      [-99, -94],
      [-290, 9],
      [-91, -92],
      [117, -29],
      [24, -122],
      [-194, -84],
      [-62, -168],
      [154, -67],
      [-20, -70],
      [183, -36],
      [-18, -101],
      [-192, 43],
      [-137, -70],
      [36, -52],
      [181, -57],
      [24, -197],
      [-119, 15],
      [-9, -101],
      [171, -76],
      [-268, -10],
      [-44, -74],
      [148, -47],
      [14, -96],
      [-170, -44],
      [-198, 68],
      [-87, -19],
      [-23, -138],
      [114, -112],
      [176, -94],
      [-3, -95],
      [83, -14],
      [-6, -180],
      [-155, -31],
      [-56, 38],
      [-71, 144],
      [-89, -22],
      [-79, -43],
      [-104, -7],
      [-69, -125],
      [142, 25],
      [40, -63],
      [98, 47],
      [168, -65],
      [-25, -132],
      [-116, -63],
      [-133, -124],
      [-431, -134],
      [-114, -30],
      [-109, -80],
      [-30, -94],
      [-106, -162],
      [-96, -21],
      [-149, -110],
      [-255, -59],
      [-30, -101],
      [-86, 5],
      [50, -121],
      [-19, -208],
      [-69, -74],
      [-26, -84],
      [-65, -6],
      [30, -177],
      [-57, -156],
      [-11, -149],
      [-186, -135],
      [-16, 73],
      [-83, 51],
      [-56, 114],
      [-46, -62],
      [-103, 9],
      [-13, 54],
      [-99, 88],
      [-46, 161],
      [-71, 61],
      [14, 57],
      [-84, 92],
      [-47, 110],
      [10, 87],
      [52, 71],
      [-38, 71],
      [-83, -12],
      [-11, 168],
      [-50, 19],
      [-86, 181],
      [57, 125],
      [-83, 32],
      [26, 161],
      [103, 156],
      [151, 18],
      [19, 223],
      [49, 58],
      [-191, 36],
      [-162, 78],
      [3, 92],
      [147, -28],
      [95, 45],
      [-119, 135],
      [-270, -17],
      [-32, 60],
      [93, 116],
      [22, 130],
      [-78, 50],
      [19, 68],
      [-80, 139],
      [-14, 105],
      [-181, 133],
      [-3, 86],
      [-106, 83],
      [-374, 106],
      [-318, -91],
      [-186, 29],
      [-214, 158],
      [-23, 85],
      [176, 15],
      [-356, 186],
      [18, 90],
      [302, 63],
      [39, 38],
      [280, 27],
      [120, 88],
      [-6, 124],
      [-204, -3],
      [-39, 62],
      [634, 259],
      [-42, 63],
      [656, 122],
      [136, -79],
      [204, -29],
      [-20, 138],
      [489, -103],
      [218, 81],
      [-271, 106],
      [134, 59],
      [328, 7],
      [292, 51],
      [622, 41],
    ],
    [
      [8644, 2272],
      [67, -37],
    ],
    [
      [8711, 2235],
      [-97, -188],
      [-13, -99],
    ],
    [
      [8601, 1948],
      [-70, -122],
      [0, -28],
    ],
    [
      [8531, 1798],
      [-59, 44],
      [-58, 5],
      [-89, 130],
    ],
    [
      [8325, 1977],
      [4, 162],
      [46, 171],
      [119, 0],
      [8, 61],
      [-32, 87],
      [-32, 38],
      [10, 197],
      [173, -1],
    ],
    [
      [9199, 2075],
      [-25, 8],
      [-46, -56],
      [-59, -34],
      [-40, 43],
      [-12, -50],
      [-70, -164],
      [-33, 45],
      [-30, -65],
      [-34, -1],
      [5, -100],
      [-57, -67],
    ],
    [
      [8798, 1634],
      [-30, 97],
      [-19, -4],
    ],
    [
      [8749, 1727],
      [10, 86],
      [-36, 40],
      [-38, -25],
      [-52, 97],
      [-32, 23],
    ],
    [
      [8711, 2235],
      [47, 43],
      [81, -35],
      [85, 30],
      [49, -7],
      [46, 26],
      [68, -38],
      [50, -115],
      [35, -5],
      [27, -59],
    ],
    [
      [10287, 2741],
      [-28, 44],
      [-78, -21],
      [-47, 25],
      [-57, -25],
      [-50, 63],
      [32, 50],
      [53, -35],
      [81, -15],
      [20, 78],
      [-25, 58],
      [8, 82],
      [-28, 38],
      [23, 75],
      [43, -42],
      [55, -9],
    ],
    [
      [9857, 2736],
      [-56, -5],
      [-35, -60],
      [-49, 30],
      [-34, 75],
      [17, 70],
      [96, -24],
      [61, -86],
    ],
    [
      [11127, 2740],
      [-9, 6],
    ],
    [
      [11118, 2746],
      [9, -6],
    ],
    [
      [7856, 4477],
      [-49, -318],
      [-12, -275],
      [-11, -139],
      [22, -216],
      [49, -217],
      [66, -170],
      [17, -121],
      [41, -131],
      [62, -2],
      [38, -41],
      [22, -73],
      [36, 0],
      [73, 56],
      [48, 0],
      [25, 39],
      [70, 15],
      [39, -53],
      [11, 94],
      [67, 109],
      [24, 120],
      [-1, 134],
      [13, 102],
      [55, 62],
      [63, 17],
      [65, 46],
      [46, 6],
      [70, -34],
      [23, 26],
      [24, -88],
      [-12, -67],
      [-55, -146],
      [2, -138],
      [-33, -252],
      [-51, 16],
    ],
    [
      [8325, 1977],
      [-56, 137],
      [-125, 229],
      [-69, 46],
      [-56, -99],
      [-77, -64],
      [-30, -6],
      [-68, 61],
      [-49, 9],
      [-104, 121],
      [-85, 44],
      [-24, 39],
      [-97, 75],
      [-114, 145],
      [-125, 92],
      [-46, 118],
      [-100, 108],
      [-48, 146],
      [-17, 82],
      [32, 78],
      [17, 149],
      [-43, 112],
      [-16, 149],
      [-60, 130],
      [-58, 164],
      [-92, 146],
      [-21, 114],
      [-76, 73],
      [-42, 64],
      [18, 154],
      [-57, 66],
      [-6, 57],
      [-61, 71],
      [-3, 99],
      [-64, 47],
      [-86, 200],
      [-11, 80],
      [-47, 130],
      [0, 57],
      [-36, 138],
      [7, 75],
      [-47, 30],
      [-32, 66],
      [-27, -22],
      [-62, 71],
      [-8, -144],
      [16, -48],
      [6, -166],
      [26, -88],
      [59, -82],
      [64, -198],
      [25, -26],
      [7, -114],
      [38, -66],
      [34, -128],
      [44, -62],
      [24, -200],
      [63, -213],
      [9, -130],
      [37, 9],
      [67, -152],
      [-5, -99],
      [-55, -20],
      [-20, 115],
      [-131, 229],
      [-39, 41],
      [1, 205],
      [-26, 102],
      [-69, 92],
      [-55, 28],
      [-17, 49],
      [-64, 63],
      [-42, 131],
      [72, -2],
      [12, 138],
      [-89, 201],
      [-69, 83],
      [-36, 232],
      [-58, 162],
      [-43, 214],
    ],
    [
      [5940, 5914],
      [230, 40],
      [-10, -47],
      [161, -114],
      [199, -141],
      [274, -2],
      [0, 99],
      [163, -1],
      [110, -202],
      [34, -38],
      [32, -106],
      [14, -115],
      [45, -72],
      [88, -77],
      [44, 166],
      [37, 32],
      [85, -28],
      [71, -142],
      [38, -183],
      [74, -154],
      [4, -114],
      [36, -142],
      [83, -72],
      [104, -24],
    ],
    [
      [9199, 2075],
      [-17, -49],
      [11, -84],
      [-23, -94],
      [-13, -147],
      [2, -155],
      [-11, -71],
      [1, -141],
      [-21, -51],
      [21, -99],
    ],
    [
      [8952, 1218],
      [-76, 149],
      [-29, 100],
      [-81, 143],
      [32, 24],
    ],
    [
      [9252, 889],
      [31, -123],
      [47, 11],
      [44, -62],
      [133, 115],
      [24, 60],
      [118, -39],
      [39, -39],
      [46, -112],
      [33, -160],
      [-13, -60],
      [-46, -51],
      [-45, 47],
      [-14, 85],
      [24, 48],
      [-55, 116],
      [-40, 40],
      [-53, -36],
      [-5, -58],
      [-65, -119],
      [44, -117],
      [-46, -55],
      [-38, -9],
      [-7, 75],
      [-56, 35],
      [-17, 91],
      [-55, 47],
      [-36, -5],
      [-23, -63],
    ],
    [
      [10744, 2844],
      [98, -10],
      [15, -95],
      [-32, -22],
      [-101, 8],
      [20, 119],
    ],
    [
      [8749, 1727],
      [-10, -54],
      [-82, 19],
      [-45, 50],
      [-54, 12],
      [-27, 44],
    ],
    [
      [11127, 2740],
      [-9, 6],
    ],
    [
      [11320, 1135],
      [1, -123],
      [-45, 36],
      [-13, 97],
      [57, -10],
    ],
    [
      [10242, 7797],
      [-44, -78],
      [-96, -43],
      [21, 80],
      [85, 9],
      [34, 32],
    ],
    [
      [5373, 9517],
      [-5, 0],
    ],
    [
      [10728, 8682],
      [19, -79],
      [-88, -86],
      [-60, -28],
      [-44, 28],
      [-13, -84],
      [-107, -74],
      [-55, -177],
      [4, -141],
      [22, -95],
      [-36, -44],
      [-43, 29],
      [-13, -83],
      [-123, -21],
      [-82, -58],
      [-62, -111],
      [30, -23],
      [-21, -142],
      [-45, -119],
      [-71, -32],
      [33, -110],
      [-40, -154],
      [-72, 108],
      [-16, -175],
      [11, -127],
      [27, -11],
      [26, -241],
      [-41, -102],
      [-22, 7],
      [-27, -144],
      [-52, -15],
      [-45, -60],
      [-35, -106],
      [-50, -5],
      [-36, -50],
      [-28, -106],
      [-159, -238],
      [-46, -139],
      [-13, -160],
      [23, -200],
      [62, -259],
      [-12, -51],
      [64, -307],
      [-6, -238],
      [-17, -113],
      [-74, -54],
      [-23, 145],
      [-46, 69],
      [-5, 76],
      [-44, 88],
      [-51, 214],
      [19, 235],
      [-73, 138],
      [-26, 85],
      [-57, 38],
      [-59, -79],
      [-45, 34],
      [-84, 116],
      [-84, 26],
      [-65, -65],
      [-109, 45],
      [-64, -63],
      [-60, 51],
      [-11, -71],
      [84, -52],
      [-60, -144],
      [-60, -11],
      [-50, 26],
      [-39, 110],
      [-47, 3],
      [-14, -48],
      [-89, 52],
      [-70, 1],
      [-92, -88],
      [-68, -134],
      [-58, -39],
      [-88, -122],
      [-42, -226],
      [41, -225],
    ],
    [
      [5940, 5914],
      [-37, 176],
      [-99, 154],
      [-38, 1],
      [-65, 82],
      [-82, 7],
      [-17, 30],
      [0, 121],
      [-24, 24],
      [-101, 272],
      [15, 69],
      [-58, 85],
      [-12, 73],
      [-58, 201],
      [-50, 88],
      [-19, 215],
      [-49, 94],
      [29, 257],
      [-47, 309],
      [38, 227],
      [22, 389],
      [0, 218],
      [-78, 331],
      [186, -19],
      [32, 118],
      [-28, 81],
    ],
    [
      [9963, 3164],
      [-7, -15],
    ],
    [
      [9969, 3148],
      [-4, 16],
    ],
    [
      [1469, 10846],
      [37, -65],
      [-141, -75],
      [28, 101],
      [76, 39],
    ],
    [
      [4589, 11039],
      [23, -53],
      [-21, -113],
      [-59, 64],
      [22, 94],
      [35, 8],
    ],
    [
      [4362, 11129],
      [38, -5],
      [116, -238],
      [3, -100],
      [-97, 107],
      [-38, 74],
      [6, 121],
      [-28, 41],
    ],
    [
      [4344, 11287],
      [76, -31],
      [-15, -101],
      [-50, -2],
      [-11, 134],
    ],
    [
      [2499, 11474],
      [52, -60],
      [-21, -82],
      [-54, -10],
      [-68, -107],
      [-54, 53],
      [-10, 115],
      [68, 65],
      [87, 26],
    ],
    [
      [4158, 11539],
      [75, -44],
      [11, -116],
      [-109, -8],
      [-44, 147],
      [67, 21],
    ],
    [
      [4234, 11571],
      [58, -86],
      [43, -133],
      [-58, 4],
      [-19, 50],
      [-24, 165],
    ],
    [
      [1244, 12013],
      [53, -100],
      [-66, -28],
      [-91, 48],
      [104, 80],
    ],
    [
      [710, 12758],
      [71, -49],
      [61, 27],
      [72, -73],
      [-54, -35],
      [-150, 130],
    ],
    [
      [4703, 11031],
      [3, -136],
      [-36, -83],
      [-54, -18],
      [-12, 82],
      [16, 113],
      [-26, 49],
      [-24, 16],
      [-51, -1],
      [-3, 76],
      [-136, 215],
      [-65, 170],
      [-67, 63],
      [-36, 97],
      [-8, -51],
      [17, -57],
      [-25, -22],
      [-68, 30],
      [-55, -36],
      [-128, 127],
      [-24, 49],
      [-205, 147],
      [-238, 90],
      [-107, -25],
      [-95, 84],
      [-170, 110],
      [-156, 3],
      [35, -99],
      [-59, -107],
      [-75, 15],
      [-94, -120],
      [-136, -67],
      [-13, 135],
      [77, 219],
      [60, 54],
      [-18, 58],
      [-106, -83],
      [-57, -97],
      [-38, -124],
      [-129, -116],
      [-11, -66],
      [83, -32],
      [-55, -69],
      [-25, -87],
      [-83, -42],
      [-35, -66],
      [-91, -68],
      [0, -52],
      [-81, -88],
      [-112, -67],
      [-31, -112],
      [-110, -23],
      [-69, -80],
      [-224, -120],
      [-15, 35],
      [116, 171],
      [125, 12],
      [15, 75],
      [136, 124],
      [119, 159],
      [20, 196],
      [40, 92],
      [-161, -83],
      [-110, 59],
      [-42, 64],
      [-97, -75],
      [-59, 89],
      [25, 81],
      [-78, 108],
      [-104, -43],
      [-132, 119],
      [-31, 52],
      [62, 54],
      [-147, 168],
      [57, 56],
      [-10, 58],
      [108, 224],
      [42, 27],
      [101, -45],
      [96, 87],
      [87, 11],
      [37, 53],
      [-60, 225],
      [-114, -59],
      [-60, 31],
      [-172, -43],
      [-111, 30],
      [-54, 104],
      [38, 47],
      [-165, 69],
      [70, 67],
      [252, 144],
      [70, 12],
      [30, -116],
      [169, -8],
      [62, 106],
      [-112, 101],
      [-120, 25],
      [-45, 113],
      [-229, 162],
      [29, 113],
      [182, 12],
      [114, 94],
      [20, 94],
      [89, 107],
      [111, 15],
      [144, 90],
      [126, 17],
      [117, 103],
      [219, -105],
      [132, 22],
      [90, -24],
      [23, -81],
      [253, 14],
      [213, -75],
      [119, 1],
      [90, -43],
      [164, 31],
      [213, -102],
    ],
  ],
  transform: {
    scale: [0.010430999585833725, 0.004568162337439118],
    translate: [-179.081776983972, 5.516047141295148],
  },
  objects: {
    continent_North_America_subunits: {
      type: "GeometryCollection",
      geometries: [
        { type: null, properties: { type: "Country", geounit: "Aruba" } },
        { type: null, properties: { type: "Geo unit", geounit: "Antigua" } },
        { type: null, properties: { type: "Geo unit", geounit: "Barbuda" } },
        { type: null, properties: { type: "Dependency", geounit: "Anguilla" } },
        {
          arcs: [[0]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "The Bahamas" },
        },
        {
          type: null,
          properties: {
            type: "Indeterminate",
            geounit: "Bajo Nuevo Bank (Petrel Is.)",
          },
        },
        {
          type: null,
          properties: { type: "Dependency", geounit: "Saint Barthelemy" },
        },
        {
          arcs: [[1, 2, 3]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Belize" },
        },
        { type: null, properties: { type: "Dependency", geounit: "Bermuda" } },
        {
          type: null,
          properties: { type: "Geo unit", geounit: "Navassa Island" },
        },
        {
          type: null,
          properties: { type: "Sovereign country", geounit: "Barbados" },
        },
        {
          arcs: [
            [[4]],
            [[5]],
            [[6, 7]],
            [[8]],
            [[9]],
            [[10]],
            [[11]],
            [[12]],
            [[13]],
            [[14]],
            [[15]],
            [[16]],
            [[17]],
            [[18, 19, 20, 21, 22, 23]],
            [[24]],
            [[25]],
            [[26]],
            [[27]],
            [[28]],
            [[29]],
            [[30]],
            [[31]],
            [[32]],
            [[33]],
            [[34]],
            [[35]],
            [[36]],
            [[37]],
            [[38]],
            [[39]],
            [[40]],
          ],
          type: "MultiPolygon",
          properties: { type: "Sovereign country", geounit: "Canada" },
        },
        {
          arcs: [[41, 42, 43, 44]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Costa Rica" },
        },
        {
          arcs: [[45, 46, 47, 48]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Cuba" },
        },
        { type: null, properties: { type: "Country", geounit: "Curacao" } },
        {
          type: null,
          properties: { type: "Dependency", geounit: "Cayman Islands" },
        },
        {
          type: null,
          properties: { type: "Sovereign country", geounit: "Dominica" },
        },
        {
          arcs: [[49, 50]],
          type: "Polygon",
          properties: {
            type: "Sovereign country",
            geounit: "Dominican Republic",
          },
        },
        { type: null, properties: { type: "Geo unit", geounit: "Guadeloupe" } },
        {
          type: null,
          properties: { type: "Sovereign country", geounit: "Grenada" },
        },
        {
          arcs: [[[51]], [[52]], [[53]], [[54]]],
          type: "MultiPolygon",
          properties: { type: "Country", geounit: "Greenland" },
        },
        {
          arcs: [[-3, 55, 56, 57, 58, 59]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Guatemala" },
        },
        {
          arcs: [[60, 61, 62, -57, 63]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Honduras" },
        },
        {
          arcs: [[-50, 64]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Haiti" },
        },
        {
          arcs: [[65]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Jamaica" },
        },
        {
          type: null,
          properties: {
            type: "Sovereign country",
            geounit: "Saint Kitts and Nevis",
          },
        },
        {
          type: null,
          properties: { type: "Sovereign country", geounit: "Saint Lucia" },
        },
        {
          arcs: [[66, 67]],
          type: "Polygon",
          properties: { type: "Dependency", geounit: "Saint Martin" },
        },
        {
          arcs: [[68, -4, -60, 69, 70]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Mexico" },
        },
        {
          type: null,
          properties: { type: "Dependency", geounit: "Montserrat" },
        },
        { type: null, properties: { type: "Geo unit", geounit: "Martinique" } },
        {
          arcs: [[71, -45, 72, -61]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Nicaragua" },
        },
        {
          type: null,
          properties: { type: "Geo unit", geounit: "Caribbean Netherlands" },
        },
        {
          arcs: [[-43, 73]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Panama" },
        },
        {
          arcs: [[74]],
          type: "Polygon",
          properties: { type: "Dependency", geounit: "Puerto Rico" },
        },
        {
          type: null,
          properties: { type: "Indeterminate", geounit: "Serranilla Bank" },
        },
        {
          arcs: [[-63, 75, -58]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "El Salvador" },
        },
        {
          type: null,
          properties: {
            type: "Dependency",
            geounit: "Saint Pierre and Miquelon",
          },
        },
        {
          arcs: [[76, -67]],
          type: "Polygon",
          properties: { type: "Country", geounit: "Sint Maarten" },
        },
        {
          type: null,
          properties: {
            type: "Dependency",
            geounit: "Turks and Caicos Islands",
          },
        },
        {
          arcs: [[77]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "Trinidad and Tobago" },
        },
        {
          type: null,
          properties: { type: "Geo subunit", geounit: "Trinidad and Tobago" },
        },
        {
          arcs: [[[78]], [[-8, 80, -71, 81, -19]]],
          type: "MultiPolygon",
          properties: { type: "Geo subunit", geounit: "United States" },
        },
        {
          arcs: [],
          type: "MultiPolygon",
          properties: {
            type: "Lease",
            geounit: "US Naval Base Guantanamo Bay",
          },
        },
        {
          arcs: [
            [[84]],
            [[85]],
            [[86]],
            [[87]],
            [[88]],
            [[89]],
            [[90]],
            [[91]],
            [[92]],
            [[-23, 93]],
          ],
          type: "MultiPolygon",
          properties: { type: "Geo subunit", geounit: "United States" },
        },
        {
          type: null,
          properties: {
            type: "Sovereign country",
            geounit: "Saint Vincent and the Grenadines",
          },
        },
        {
          type: null,
          properties: { type: "Dependency", geounit: "British Virgin Islands" },
        },
        {
          type: null,
          properties: {
            type: "Dependency",
            geounit: "United States Virgin Islands",
          },
        },
      ],
    },
  },
};
